import { Text } from '@mantine/core';
import storage from '@/utils/storage';

export const SignupTerms = () => {
  const config = storage.getItem('config');
  const signupTerms = config?.signup_terms;
  const terms = signupTerms?.terms_and_policy_text;
  const termsStartIndex = signupTerms?.terms_start_index;
  const termsEndIndex = signupTerms?.terms_end_index;
  const termsPolicyUrl =
    signupTerms?.terms_policy_url || 'https://hungerbox.com/terms-and-conditions.html';
  const privacyPolicyStartIndex = signupTerms?.privacy_policy_start_index;
  const privacyPolicyEndIndex = signupTerms?.privacy_policy_end_index;
  const privacyPolicyUrl =
    signupTerms?.privacy_policy_url || 'https://hungerbox.com/privacy-policy.html';
  const companyPolicyStartIndex = signupTerms?.company_policy_start_index;
  const companyPolicyEndIndex = signupTerms?.company_policy_end_index;
  const companyPolicyUrl = signupTerms?.company_policy_url;

  const termsClick = () => {
    window.open(termsPolicyUrl, '_blank');
  };

  const privacyClick = () => {
    window.open(privacyPolicyUrl, '_blank');
  };

  const companyClick = () => {
    window.open(companyPolicyUrl, '_blank');
  };

  if (!signupTerms) {
    return null;
  }

  if (
    !terms ||
    !termsStartIndex ||
    !termsEndIndex ||
    !privacyPolicyStartIndex ||
    !privacyPolicyEndIndex
  ) {
    return null;
  }

  return (
    <Text span c="gray" lh={1.2}>
      {terms.substring(0, termsStartIndex)}
      <Text c="primary" span fw="600" className="pointer" onClick={termsClick} lh={1.2}>
        {terms.substring(termsStartIndex, termsEndIndex)}
      </Text>
      <Text span c="gray" lh={1.2}>
        {terms.substring(termsEndIndex, privacyPolicyStartIndex)}
      </Text>
      <Text c="primary" span fw="600" className="pointer" onClick={privacyClick} lh={1.2}>
        {terms.substring(privacyPolicyStartIndex, privacyPolicyEndIndex)}
      </Text>
      {companyPolicyStartIndex && companyPolicyEndIndex ? (
        <>
          <Text span c="gray" lh={1.2}>
            {terms.substring(privacyPolicyEndIndex, companyPolicyStartIndex)}
          </Text>
          <Text
            c={companyPolicyUrl ? 'primary' : 'gray'}
            span
            fw={companyPolicyUrl ? '600' : '400'}
            className="pointer"
            onClick={companyClick}
            lh={1.2}
          >
            {terms.substring(companyPolicyStartIndex, companyPolicyEndIndex)}
          </Text>
          <Text span c="gray" lh={1.2}>
            {terms.substring(companyPolicyEndIndex)}
          </Text>
        </>
      ) : null}
    </Text>
  );
};
